import { render, staticRenderFns } from "./ModalTeacherTeachingOfferings.vue?vue&type=template&id=2d3c5e3b&scoped=true&"
import script from "./ModalTeacherTeachingOfferings.vue?vue&type=script&lang=js&"
export * from "./ModalTeacherTeachingOfferings.vue?vue&type=script&lang=js&"
import style0 from "./ModalTeacherTeachingOfferings.vue?vue&type=style&index=0&id=2d3c5e3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c5e3b",
  null
  
)

export default component.exports